import { formatDisplayDate } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import type { IntlShape } from "react-intl";
import { getEndDateForPeriodText } from "shared-ui";

import { COMMON_MESSAGES } from "../../common-messages";

dayjs.extend(LocalizedFormat);
dayjs.extend(utc);

const getUtcCalendarDay = (date: string): string => dayjs.utc(date).format("YYYY-MM-DD");

export const formatAirPeriod = (intl: IntlShape, period: FundingApplicationSchemas.DateTimeRangeSchema): string =>
  intl.formatMessage(COMMON_MESSAGES.periodText, {
    dateFrom: formatDisplayDate(dayjs(getUtcCalendarDay(period.start)).startOf("month")),
    dateTo: formatDisplayDate(getEndDateForPeriodText(period.end && getUtcCalendarDay(period.end))),
  });
